export default __webpack_public_path__ + "static/media/drone15.6d213535.webp";